// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getSafeCipUrl } from '@tectonics/prs/incoming-payment';
import { SaveAttachmentButton } from '../../../../commons/molecules';

export function SaveAsPdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const href = `${getSafeCipUrl(incomingPayment)}&format=pdf`;

  return <SaveAttachmentButton href={href} outline>Guardar Instrucciones en PDF</SaveAttachmentButton>;
}
